import React, { useState } from 'react';
import { useBrand } from '../../contexts/BrandContext';
import BrandMark from './BrandMark';

export default function BrandedLogo({ className = "h-8 w-auto", showText = true }) {
  const { brand } = useBrand();
  const [imageFailed, setImageFailed] = useState(false);

  // brand.logo points at files that do not exist in public/assets (see BrandMark), so
  // in practice this always renders the vector mark today. The <img> path is kept so a
  // real designed logo can be dropped in later by setting BRAND_CONFIG.logo — but a
  // FAILED load now falls back to the mark instead of hiding the element, which is what
  // left both brands showing bare text with no logo at all.
  const showImage = Boolean(brand?.logo) && !imageFailed;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showImage ? (
        <img
          src={brand.logo}
          alt={`${brand.name} Logo`}
          className="h-8 w-auto"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <BrandMark className="h-8 w-8" />
      )}

      {/* Brand Name Text */}
      {showText && (
        <span className="text-xl font-bold text-gray-900 dark:text-white">
          {brand.name}
        </span>
      )}
    </div>
  );
}

// Compact version for navigation
export function BrandedLogoCompact({ className = "h-6 w-auto" }) {
  return <BrandedLogo className={className} showText={false} />;
}

// Large version for login/signup pages
export function BrandedLogoLarge({ className = "h-12 w-auto" }) {
  return <BrandedLogo className={className} showText={true} />;
}